<template>
    <div class="o-alerts">
        <div class="o-alerts__heatmap" id="mapDiv" ref="heatmap"></div>
        <div class="l-row m-card">
            <div class="l-row__column m-card__column">
                <div class="l-row m-card__container">
                    <m-control
                        v-if="dateRange"
                        type="dateRange"
                        name="dateRange"
                        label="Zakres dat"
                        :value="dateRange"
                        @input="dateRange = $event"
                    />
                    <m-control
                        :background-gray="true"
                        type="searchText"
                        label="Uprawy"
                        placeholder="Znajdź..."
                        name="crops"
                        model-name="crops"
                        @input="build('crops', $event)"
                        :value="query['crops']"
                    />
                    <m-control
                        :background-gray="true"
                        type="searchText"
                        label="Region"
                        placeholder="Znajdź..."
                        name="counties"
                        model-name="counties"
                        @input="build('county', $event)"
                        :value="query['county']"
                    />
                    <m-control
                        :background-gray="true"
                        type="searchText"
                        label="Agrofagi"
                        placeholder="Znajdź..."
                        name="agrofags"
                        model-name="agrofags"
                        @input="build('agrofags', $event)"
                        :value="query['agrofags']"
                    />
                </div>
            </div>
        </div>
        <o-list
            vuex-action-fetch="fetchAlerts"
            vuex-action-fetch-next-page="fetchAlertsNextPage"
            vuex-getter-model="alerts"
            vuex-getter-status="alertsStatus"
            router-single-name="alert"
        >
            <template slot="list" slot-scope="props">
                <p class="m-list__itemTitle m-list__itemTitle--bold">
                    {{ `Alert ${props.list.item.id}` }}
                </p>
                <p class="m-list__itemDate">
                    {{
                        $dayjs(props.list.item.created_at).format(
                            'DD.MM.YYYY, HH:mm:ss'
                        )
                    }}
                </p>
                <div class="m-list__itemHeader">
                    <div
                        v-if="
                            props.list.item.agrofags &&
                                props.list.item.agrofags.length > 0
                        "
                        class="m-list__itemHeaderCell"
                    >
                        <a-icon
                            class="m-list__icon m-list__icon--header"
                            icon="AgrofagSmall"
                        />
                        {{ props.list.item.agrofags[0].name }}
                        <template v-if="props.list.item.agrofags.length > 1"
                            ><br />i inne</template
                        >
                    </div>
                    <div
                        v-if="
                            props.list.item.crops &&
                                props.list.item.crops.length > 0
                        "
                        class="m-list__itemHeaderCell"
                    >
                        <a-icon
                            class="m-list__icon m-list__icon--header"
                            icon="CropSmall"
                        />
                        {{ props.list.item.crops[0].name }}
                        <template v-if="props.list.item.crops.length > 1"
                            ><br />i inne</template
                        >
                    </div>
                    <div
                        v-if="
                            props.list.item.counties &&
                                props.list.item.counties.length > 0
                        "
                        class="m-list__itemHeaderCell"
                    >
                        <a-icon
                            class="m-list__icon m-list__icon--header"
                            icon="RegionSmall"
                        />
                        {{ props.list.item.counties[0].name }}
                        <template v-if="props.list.item.counties.length > 1"
                            ><br />i inne</template
                        >
                    </div>
                </div>
                <div
                    v-if="props.list.item.description_trunc"
                    class="m-list__itemDescription"
                >
                    {{ props.list.item.description_trunc }}
                </div>
            </template>
        </o-list>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Alerty',
        meta: [
            {
                name: 'viewport',
                content:
                    'width=device-width,initial-scale=1.0,maximum-scale=1.0'
            }
        ]
    },
    data() {
        return {
            date: {
                startDate: this.$dayjs()
                    .subtract('14', 'day')
                    .format('YYYY-MM-DD'),
                endDate: this.$dayjs().format('YYYY-MM-DD')
            },
            timeout: null
        }
    },
    computed: {
        query() {
            return this.$store.getters.alertsQuery
        },
        dateRange: {
            get() {
                return this.date
            },
            set(dateRange) {
                this.$set(this, 'date', dateRange)
                this.buildDate('date_start', dateRange.startDate)
                setTimeout(() => {
                    this.buildDate('date_end', dateRange.endDate)
                }, 1000)
            }
        },
        alerts() {
            return this.$store.getters.alerts
        },
        alertsStatus() {
            return this.$store.getters.alertsStatus
        },
        heatmapPoints() {
            return this.alerts.reduce((accumulator, alert) => {
                const counties = alert.counties.map(item =>
                    JSON.parse(item.poly_center)
                )
                return accumulator.concat(counties)
            }, [])
        }
    },
    watch: {
        alertsStatus() {
            if (window.google !== undefined) {
                const heatmapData = this.heatmapPoints.map(
                    item => new window.google.maps.LatLng(item[1], item[0])
                )
                const heatmap = new window.google.maps.visualization.HeatmapLayer(
                    {
                        data: heatmapData
                    }
                )
                const map = new window.google.maps.Map(this.$refs.heatmap, {
                    center: new window.google.maps.LatLng(52.126525, 19.400937),
                    zoom: 5,
                    disableDefaultUI: true
                })
                const styles = [
                    {
                        featureType: 'poi.business',
                        stylers: [{ visibility: 'off' }]
                    },
                    {
                        featureType: 'transit',
                        elementType: 'labels.icon',
                        stylers: [{ visibility: 'off' }]
                    }
                ]
                map.setOptions({ styles: styles })
                heatmap.setMap(map)
                heatmap.set('radius', 20)
            }
        }
    },
    methods: {
        build(name, value) {
            if (this.timeout) clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                this.$store
                    .dispatch('setAlertsSearchQuery', {
                        name,
                        value
                    })
                    .then(() => {
                        this.$store.dispatch('fetchAlerts').catch(() => {})
                    })
            }, 500)
        },
        buildDate(name, value) {
            this.$store
                .dispatch('setAlertsSearchQuery', {
                    name,
                    value
                })
                .then(() => {
                    this.$store.dispatch('fetchAlerts').catch(() => {})
                })
        },
        handleGoogleMaps() {}
    },
    created() {
        this.$store.dispatch('setAlertsSearchQuery', {
            name: 'status_symbol',
            value: 'published'
        })
        this.$store.dispatch('setAlertsSearchQuery', {
            name: 'date_start',
            value: this.date.startDate
        })
        this.$store.dispatch('setAlertsSearchQuery', {
            name: 'date_end',
            value: this.date.endDate
        })
        window.checkAndAttachMapScript(this.handleGoogleMaps)
    }
}
</script>
